// Vendors
import React from 'react';

// Components
import GasRepFields from './GasRepFields';

const PropaneProvider = ({
  projectData,
  handleChangeView,
  handleSaveProject,
  updateSpecificProjectDataProperty
}) => {
  const allPropaneProviderFieldsOk = () => {
    return (
      projectData.gas_rep_company_name &&
      projectData.gas_rep_representative &&
      projectData.gas_rep_city &&
      projectData.gas_rep_state 
    );
  };

  return (
    <div id="upload-epat">
      <div className="grid u--font-size-lg" style={{ maxWidth: '600px' }}>
        <GasRepFields
          projectData={projectData}
          updateSpecificProjectDataProperty={updateSpecificProjectDataProperty}
        />
      </div>
      <div className="grid u--font-size-lg">
        <div className="grid__col-xs-12">
          <button
            id="pip-add__save-epat"
            className={`btn btn--gold btn--lg module-hover-root`}
            type="button"
            onClick={handleSaveProject}
            disabled={!allPropaneProviderFieldsOk()}
          >
            <span className="btn__content">
              <span className="btn__text">Save Propane Provider</span>
            </span>
          </button>
          <span
            className="btn btn--white btn--lg module-hover-root u--margin-left-30"
            onClick={() => handleChangeView('project-form')}
          >
            <span className="btn__content">
              <span className="btn__text">Back to Project Overview</span>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};
export default PropaneProvider;
